import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId && measurementId !== "G-XXXXXXXXXX") {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        debug_mode: process.env.NODE_ENV === "development",
      },
    });
    console.log("📊 Google Analytics initialized:", measurementId);
    return true;
  } else {
    console.log(
      "📊 Google Analytics not configured (missing REACT_APP_GA_MEASUREMENT_ID)"
    );
    return false;
  }
};

// Track page views
export const trackPageView = (path) => {
  if (
    process.env.REACT_APP_GA_MEASUREMENT_ID &&
    process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX"
  ) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  if (
    process.env.REACT_APP_GA_MEASUREMENT_ID &&
    process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX"
  ) {
    const eventData = {
      category,
      action,
    };
    if (label) eventData.label = label;
    if (value !== null) eventData.value = value;

    ReactGA.event(eventData);
  }
};

// Specific tracking functions for your app
export const trackSearch = (searchType, details) => {
  trackEvent("Search", searchType, JSON.stringify(details));
};

export const trackUserZipEntry = (zipCode, bedrooms) => {
  trackEvent("User_Location", "Enter ZIP", zipCode, bedrooms);
};

export const trackCitySearch = (searchQuery) => {
  trackEvent("City_Search", "Search Query", searchQuery);
};

export const trackComparison = (userZip, cities, bedrooms) => {
  // Track the main comparison event
  trackEvent(
    "Comparison",
    "Compare Rent",
    `${userZip} vs ${cities.length} cities`,
    cities.length
  );

  // Track which specific cities were compared
  cities.forEach((city) => {
    trackEvent(
      "Comparison_Details",
      "City Compared",
      `${city.city}, ${city.state}`,
      bedrooms
    );
  });

  // Track the user's ZIP in comparisons
  trackEvent("Comparison_User_ZIP", "User ZIP Code", userZip, bedrooms);
};

export const trackCitySelection = (city, state) => {
  trackEvent("City", "Select City", `${city}, ${state}`);
};

export const trackShare = (method) => {
  trackEvent("Share", "Share Results", method);
};

export const trackError = (errorType, errorMessage) => {
  trackEvent("Error", errorType, errorMessage);
};

export const trackImageLoad = (city, state, success) => {
  trackEvent(
    "Image",
    success ? "Load Success" : "Load Failed",
    `${city}, ${state}`
  );
};
